import { Component, Input, OnInit } from '@angular/core';
import { Overlay, ScrollStrategy, ConnectedPosition, CdkOverlayOrigin } from '@angular/cdk/overlay';

@Component({
    selector: 'fcp-tooltip',
    templateUrl: './fcp-tooltip.component.html',
    styleUrls: ['./fcp-tooltip.component.less'],
    standalone: false
})
export class FcpTooltipComponent implements OnInit {
    @Input() overlayOrigin: CdkOverlayOrigin;
    @Input() open: boolean;
    @Input() customPosition: TooltipPosition = {
        originX: TooltipPositionX.Start,
        originY: TooltipPositionY.Top
    };

    public positions: ConnectedPosition[];
    // Tell the tooltip to follow the anchorElement as the page is scrolling
    public scrollStrategy: ScrollStrategy = this.overlay.scrollStrategies.reposition();

    public tooltipPositionClassName: string;

    constructor(private overlay: Overlay) {}

    ngOnInit() {
        const tooltipPosition: ConnectedPosition = {
            originX: this.customPosition.originX,
            originY: this.customPosition.originY,
            overlayX: this.customPosition.originX,
            overlayY: this.customPosition.originY
        };

        this.tooltipPositionClassName = `fcp-tooltip fcp-tooltip-${this.customPosition.originX}-${this.customPosition.originY}`;

        this.positions = [tooltipPosition];
    }
}

export interface TooltipPosition {
    originX: TooltipPositionX;
    originY: TooltipPositionY;
}

export enum TooltipPositionX {
    Start = 'start',
    Center = 'center',
    End = 'end'
}

/** TODO: implement CSS rules for combinations witth central position */
export enum TooltipPositionY {
    Top = 'top',
    Bottom = 'bottom'
}
